import ScrollAnimation from './ScrollAnimation';

function BusinessTypes() {
  const businessTypes = [
    {
      id: 1,
      name: "المطاعم والمقاهي",
      description: "قسم الفواتير، أضف البقشيش، وأدر طلبات الطاولات بسهولة تامة.",
      image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600&h=400&fit=crop&q=80",
      icon: "🍽️"
    },
    {
      id: 2,
      name: "المتاجر التجزئة",
      description: "دفع سريع، مزامنة المخزون، وبرامج ولاء العملاء مدمجة.",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop&q=80",
      icon: "🛍️"
    },
    {
      id: 3,
      name: "عربات الطعام",
      description: "محمول، متين، ويعمل في أي مكان مع اتصال 4G.",
      image: "https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=600&h=400&fit=crop&q=80",
      icon: "🚚"
    },
    {
      id: 4,
      name: "الصالونات والمنتجعات",
      description: "حجز المواعيد والدفع في تجربة سلسة واحدة.",
      image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&h=400&fit=crop&q=80",
      icon: "💇"
    },
    {
      id: 5,
      name: "المحلات الصغيرة",
      description: "حل مثالي للمشاريع الصغيرة والمتوسطة بأسعار مناسبة.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop&q=80",
      icon: "🏪"
    },
    {
      id: 6,
      name: "السوبر ماركت",
      description: "إدارة فواتير متعددة، مسح الباركود، وتقارير مبيعات شاملة.",
      image: "https://images.unsplash.com/photo-1556912167-f556f1f39f0b?w=600&h=400&fit=crop&q=80",
      icon: "🛒"
    }
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden" id="business-types">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-500 font-bold tracking-wider uppercase text-sm mb-2 block">
            مناسب لجميع الأعمال
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            مصمم من أجل{' '}
            <span className="text-primary-500">كل نوع من الأعمال</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            من المحلات الصغيرة إلى السلاسل متعددة الفروع، يتكيف جهازنا مع صناعتك
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {businessTypes.map((business, index) => (
            <ScrollAnimation key={business.id} variant="fade-up" delay={index * 100}>
              <div className="group relative overflow-hidden rounded-2xl aspect-[4/5] cursor-pointer bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
                {/* Background Image */}
                <div className="absolute inset-0">
                  <img
                    src={business.image}
                    alt={business.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" />
                
                {/* Content */}
                <div className="absolute inset-0 p-6 flex flex-col justify-end">
                  <div className="text-4xl mb-3">{business.icon}</div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {business.name}
                  </h3>
                  <p className="text-white/80 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {business.description}
                  </p>
                </div>

                {/* Number Badge */}
                <div className="absolute top-4 right-4 w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-sm">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BusinessTypes;
